const nf = new Intl.NumberFormat('ro-RO');
const cf = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const df = new Intl.DateTimeFormat('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' });
const dtf = new Intl.DateTimeFormat('ro-RO', { dateStyle: 'medium', timeStyle: 'short' });

export function formatNumberRo(n: number): string {
  return nf.format(n);
}

/** `347,20 €` — Romanian decimal comma + trailing euro sign. */
export function formatCurrencyEurRo(eur: number): string {
  return `${cf.format(eur)} €`;
}

/** `13 iulie 2026`. */
export function formatDateRo(d: Date): string {
  return df.format(d);
}

/** `13 iul. 2026, 14:05` — date + time, for tables where multiple same-day
 *  entries must stay distinguishable (ledger, instance sessions). Guards
 *  against an empty/invalid ISO string by returning „—" instead of throwing
 *  or rendering "Invalid Date". */
export function formatDateTimeRo(iso: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return dtf.format(d);
}

/**
 * Elapsed wall-clock for a running instance session — `m:ss` under an hour,
 * `h:mm:ss` past it. Lives here (not in `SessionDrawer`, where it started)
 * because the docked chip in `DocTop` shows the same clock: two copies would
 * be free to drift apart. A negative input (clock skew between server-stamped
 * `startedAt` and the browser) clamps to zero rather than printing `-1:-05`.
 */
export function formatElapsedRo(ms: number): string {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  return h > 0
    ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    : `${m}:${String(s).padStart(2, '0')}`;
}
